module.exports = __webpack_public_path__ + "img/Mask Group 127.d11c1905.svg";